import * as yup from 'yup';

export const ReferredByValidationSchema = yup.object().shape(
	{
		name: yup
			.string()
			.nullable()
			.max(150, 'Name must be less than 150 Characters'),
		surname: yup
			.string()
			.nullable()
			.max(150, 'Surname must be less than 150 Characters'),
		email: yup
			.string()
			.nullable()
			.email('Invalid email address'),
		isConsultantUsed: yup
			.bool()
			.nullable(),
		consultantName: yup
			.string()
			.nullable()
			.max(150, 'Name of Consultant must be less than 150 Characters'),
		consultantemail: yup
			.string()
			.nullable()
			.email('Invalid email address'),
	}
);
